import { returnPath } from '../firebase/authSession';

// This identifies an in-app navigation, not a user or an authentication session.
// A refreshed/shared URL opens as a page, even if history retains old modal state.
const pageSession = Math.random().toString(36).slice(2);
export function chapterPath(id) {
  return typeof id === 'string' && /^[a-z0-9_-]+$/i.test(id) ? `/chapters/${id}` : null;
}
export function chapterBackground(location) {
  const state = location.state;
  const background = state && state.chapterBackground;
  if (!/^\/chapters\/[a-z0-9_-]+\/?$/i.test(location.pathname) || !state || state.chapterSession !== pageSession || !background) return null;
  if (typeof background.pathname !== 'string' || returnPath(background.pathname) !== background.pathname) return null;
  return background;
}
export function chapterLink(id, location) {
  const background = chapterBackground(location) || location;
  return {
    pathname: chapterPath(id),
    state: { chapterSession: pageSession, chapterBackground: {
      pathname: background.pathname, search: background.search || '', hash: background.hash || '', key: background.key,
    } },
  };
}
